<template>
  <div :class="{ 'basic-card': true, 'blank': blank, 'no-background': noBackground }">
    <template v-if="!blank">
      <div class="basic-card-header">
        <div class="basic-card-title">
          <slot name="header"/>
        </div>
      </div>
      <div class="basic-card-content">
        <slot/>
      </div>
    </template>
    <template v-else>
      <div class="basic-card-content">
        <slot/>
      </div>
    </template>

  </div>
</template>

<script>
export default {
  name: "BasicCard",
  props: {
    blank: Boolean,
    noBackground: Boolean
  },
  data: function () {
    return {}
  }
}
</script>

<style lang="scss" scoped>
@import "../../styles/global";
.basic-card {
  display: flex;
  flex-flow: column;
  color: var(--card-font-color);
  width: 100%;
  -webkit-column-break-inside: avoid;
  margin-bottom: 20px;
  box-shadow: 0px 0px 20px rgb(0,0,0, 1);
}

.no-background {
  background-color: transparent;
}

.blank {
  background-color: transparentize(lighten(#262C32, 5), 0.5);
  border: 2px dotted var(--card-background-color);
  font-size: 20px;
  width: 100%;
  -webkit-column-break-inside: avoid;
  justify-content: center;
  align-items: center;
}

.basic-card-content {
  &::-webkit-scrollbar-track {
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  }

  &::-webkit-scrollbar-thumb {
    background-color: lighten($backgroundColor, 20);
    border: 4px solid var(--card-background-color);
  }

  &::-webkit-scrollbar {
    width: 6px;
  }

  padding: 5px 20px 20px 20px;
  background-color: var(--card-background-color);
  //overflow: auto;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
}

.basic-card-title {
  display: flex;
  flex-flow: row;
  align-items: center;
  justify-items: center;
  padding: 10px 20px 5px 10px;
  font-size: 16px;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  width: 100%;
  white-space: nowrap;
  background-color: var(--card-background-color);
}

.basic-card-header {
  background-color: transparent;
}
</style>